import * as z from 'zod/v4-mini';

export const notEmpty = z.minLength(1, '$t:validation.not_empty');
export const nonEmptyString = (params?: Parameters<typeof z.string>[0]) =>
	z.string({ error: '$t:validation.not_empty', ...(typeof params === 'string' ? { error: params } : params) }).check(notEmpty);

export const DbSafeString = z.string({ error: '$t:validation.not_empty' }).check(notEmpty, z.regex(/^\w+$/, '$t:validation.db_safe_string'));
export const ApiSafeString = z.string({ error: '$t:validation.not_empty' }).check(notEmpty, z.regex(/^\w[\w-]*$/, '$t:validation.api_safe_string'));
